import React from "react";
import { serviceCardData } from "../../thirdUtils/constant";
import { FaArrowRight } from "react-icons/fa6";
import ServiceHeader from "./ServiceHeader";

const ServiceCard = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    return (
        <>
            <ServiceHeader {...props} title={selectedLanguage?.our_services_heading} heading={selectedLanguage?.txt_what_service_we_offer} text={selectedLanguage?.txt_it_is_important_to_take_sufferings} />
            <div className="third-design-service-cards-main">
                {
                    serviceCardData?.map((v, i) => {
                        return (
                            <div data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-delay="100"
                                data-aos-offset="0"
                                data-aos-duration="1500" className={i === 0 || i === 2 || i === 4 ? 'third-design-service-card' : ''}>
                                <div>
                                    <img src={v?.icon} alt="" />
                                </div>
                                <div className="service-card-text-div">
                                    <h2>
                                        {isELSelect ? v?.title : (isAlSelect ? v?.alTitle : v?.glTitle)}
                                    </h2>
                                    <p>
                                        {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                    </p>
                                    <button>{selectedLanguage?.txt_learn_more} <FaArrowRight /></button>
                                </div>
                            </div>
                        )
                    })
                }
            </div></>
    )
}

export default ServiceCard